<script>
  import { RolesRepository } from "../../repositories/index"
  import { onMount, getContext } from "svelte"
  import { _, callout } from "../../stores/index"
  import { Button, Flex, FlexItem, Icon, Text } from "@gl/design-system"

  import { PoliciesTable } from "../../components/index"
  const { isAuthorized } = getContext("isAuthorized")
  import { navigate } from "../../utils/index"

  export let id

  let policies
  let loading = {}
  let policiesTable

  async function getRolePolicies() {
    try {
      loading.policies = true

      const result = await RolesRepository.getRolePolicies(id)
      policies = result.list
    } finally {
      loading.policies = false
    }
  }

  async function handleSave() {
    loading.submit = true

    let selected = policiesTable.getSelected()

    let policiesToAdd = selected.filter((s) => !policies.includes(s))

    let policiesToRemove = policies.filter((p) => !selected.includes(p))

    if (policiesToAdd.length === 0 && policiesToRemove.length === 0) {
      callout.set({
        msg: $_("no.changes.callout"),
        status: "warning",
        timeout: true,
      })
      loading.submit = false
      navigate("/roles")
      return
    }

    try {
      if (policiesToAdd.length) {
        await RolesRepository.addRolePolicies(id, {
          policies: policiesToAdd,
        })
      }

      if (policiesToRemove.length) {
        await RolesRepository.deleteRolePolicies(id, {
          policies: policiesToRemove,
        })
      }
      callout.set({
        msg: $_("policies.save.callout"),
        status: "success",
        timeout: true,
      })
    } finally {
      loading.submit = false
      navigate("/roles")
    }
  }

  onMount(() => {
    getRolePolicies()
  })
</script>

{#if policies}
  <PoliciesTable subPolicies={policies} bind:this={policiesTable} />
{/if}

{#if $isAuthorized("role_write")}
  <div class="footer-buttons py-6">
    <Button
      on:click={() => {
        getRolePolicies()
        policiesTable.reset()
      }}
      outlined>{$_("common.reset")}</Button
    >
    <FlexItem pushEnd>
      <Button on:click={handleSave} class="mr-3" loading={loading.save}>{$_("buttons.save")}</Button>
      <Button on:click={() => navigate("/roles")} outlined>{$_("buttons.cancel")}</Button>
    </FlexItem>
  </div>
{/if}
